module.exports = "<p>\r\n  awsop-lab9 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab9/awsop-lab9.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab9/awsop-lab9.component.html
// module chunks = main